// src/features/faq/components/LatestRegistrationsFAQs.tsx

import React from 'react';
// ELIMINAMOS: import { useNavigate } from 'react-router-dom';
import { UserPlus } from 'lucide-react'; // Search no se usa aquí, se puede quitar si no se usa en otras FAQs de este módulo

export interface LatestRegistrationsFAQItem {
  id: string;
  question: string;
  answer: React.ReactNode;
}

interface LatestRegistrationsFAQData {
  id: string;
  title: string;
  icon: React.ReactNode;
  description: string;
  faqs: LatestRegistrationsFAQItem[];
}

// AÑADIMOS el parámetro 'navigateCallback'
export const LatestRegistrationsFAQs = (navigateCallback: (path: string) => void): LatestRegistrationsFAQData => {
  // ELIMINAMOS: const navigate = useNavigate();

  return {
    id: 'latest-registrations',
    title: 'Últimos Registros',
    icon: <UserPlus className="h-5 w-5 text-green-600 dark:text-green-400" />,
    description: 'Visualización y gestión de clientes recién registrados en tu programa.',
    faqs: [
      {
        id: 'registrations-purpose',
        question: '¿Para qué sirve la página de Últimos Registros?',
        answer: (
          <div>
            <p>La página de "Últimos Registros" te ofrece una vista cronológica de los clientes que se han inscrito más recientemente en tu programa de lealtad. Sus principales utilidades son:</p>
            <ul className="list-disc ml-5 mt-2 space-y-1">
              <li>Ver de un vistazo quiénes son tus nuevos clientes.</li>
              <li>Verificar rápidamente que la información capturada durante el registro sea correcta.</li>
              <li>Filtrar y buscar entre estos registros recientes si necesitas encontrar a alguien específico.</li>
              <li>Monitorear la efectividad de campañas de captación o el flujo general de nuevos miembros por fecha.</li>
            </ul>
            <p className="mt-2 text-content-2">Es una herramienta útil para el seguimiento inicial de nuevos clientes y para asegurar la calidad de los datos desde el inicio.</p>
            <div className="mt-2">
              <button onClick={() => navigateCallback('/dashboard/latest-registrations')} className="inline-flex items-center text-sm text-accent hover:text-blue-800 dark:text-blue-300">
                <UserPlus className="h-4 w-4 mr-1.5" />
                Ir a Últimos Registros
              </button>
            </div>
          </div>
        )
      },
      {
        id: 'registrations-data',
        question: '¿Qué información de los nuevos registros puedo consultar aquí?',
        answer: (
          <div>
            <p>En la página de "Últimos Registros", para cada cliente recién inscrito, generalmente podrás ver:</p>
            <ul className="list-disc ml-5 mt-2 space-y-1">
              <li><strong>Nombre del cliente:</strong> Tal como fue proporcionado durante el registro.</li>
              <li><strong>Información de contacto:</strong> Número de teléfono y, si se solicitó y proporcionó, su correo electrónico.</li>
              <li><strong>Fecha y hora exacta del registro:</strong> Para un seguimiento preciso.</li>
              <li><strong>Datos opcionales:</strong> La fecha de cumpleaños, si configuraste solicitarla en <button onClick={() => navigateCallback('/dashboard/business?tab=kiosk')} className="text-accent hover:text-blue-800 dark:text-blue-300 font-medium">Mi Negocio</button>.</li>
            </ul>
            <p className="mt-2 text-content-2">Los registros suelen estar agrupados por día para facilitar la revisión y el seguimiento cronológico.</p>
          </div>
        )
      },
      {
        id: 'registrations-search',
        question: '¿Cómo puedo buscar un registro específico entre los más recientes?',
        answer: (
          <div>
            <p>Si necesitas encontrar un cliente particular entre los últimos registros:</p>
            <ol className="list-decimal ml-5 mt-2 space-y-1">
              <li>Ve a la página de <button onClick={() => navigateCallback('/dashboard/latest-registrations')} className="text-accent hover:text-blue-800 dark:text-blue-300 font-medium">Últimos Registros</button>.</li>
              <li>Utiliza la barra de búsqueda que normalmente se encuentra en la parte superior.</li>
              <li>Puedes buscar por nombre, teléfono o correo del cliente.</li>
              <li>La lista de registros se filtrará automáticamente a medida que escribes, mostrando solo los que coinciden con tu búsqueda.</li>
            </ol>
            <div className="mt-2 bg-blue-50 dark:bg-blue-500/10 p-3 rounded-md border border-blue-200 dark:border-blue-500/30">
              <p className="text-sm text-blue-700 dark:text-blue-300">
                <strong>Consejo:</strong> Esta función de búsqueda es muy útil justo después de realizar campañas de captación o eventos, para verificar rápidamente los nuevos ingresos o encontrar a alguien que se acaba de registrar.
              </p>
            </div>
          </div>
        )
      },
    ]
  };
};

// export default LatestRegistrationsFAQs; // Opcional